import React from "react";
import { getAssets } from "@unisearch/helpers";
import { IoDocumentTextOutline } from "react-icons/io5";

import styles from "./top_uni_box.module.scss";

const TopUniBox = (props) => {
  return (
    <div className={styles.top_uni}>
      <div className={styles.top_uni_border}>
        <div className={styles.image}>
          <img
            src={getAssets("assets/images/university-logo.png")}
            alt="university logo"
          />
        </div>
        <a href="#">
          <p className={styles.name}>The University of Melbourne</p>
        </a>
        <p className={styles.estd}>Public university, Estd 1853</p>
        <p className={styles.location}>Melbourne, Victoria</p>

        <div className={styles.links}>
          <a className={styles.popular_courses} href="#">
            <span className={styles.first}>+</span>
            <span className={styles.last}>Popular Courses</span>
          </a>
          <a className={styles.all_courses} href="#">
            View all 331 Courses ›
          </a>
        </div>

        <p className={styles.desc}>
          The University of Melbourne was founded by Hugh Culling Eardley
          Childers in 1853. It is the second oldest university of higher
          education and research.
        </p>
        <div className={styles.buttons}>
          <button className={styles.first}>+ Follow</button>
          <a href="#" className={styles.last}>
            <IoDocumentTextOutline />
            <span>Download Brochure</span>
          </a>
        </div>
      </div>
    </div>
  );
};

export default TopUniBox;
